/**
 * 短い区間の FASTA / GenBank テキスト（書き出し I28–I31）。
 * 染色体全長は `.gproj` を使う。ここは走査窓〜数 Mbp 向け。
 */

import type { Topology } from '../sequence/interval';
import type { GenomicFeatureV1 } from '../annotation/types';
import { decodeCodes } from '../sequence/nucleotideCodes';

export function formatFastaText(name: string, codes: Uint8Array, wrap = 70): string {
  const seq = decodeCodes(codes);
  const lines = [`>${name.replace(/\s+/g, '_')}`];
  for (let i = 0; i < seq.length; i += wrap) {
    lines.push(seq.slice(i, i + wrap));
  }
  return `${lines.join('\n')}\n`;
}

export function formatGenBankText(params: {
  name: string;
  codes: Uint8Array;
  topology: Topology;
  features?: GenomicFeatureV1[];
  definition?: string;
}): string {
  const seq = decodeCodes(params.codes).toLowerCase();
  const locus = params.name.replace(/[^\w.-]/g, '_').slice(0, 16) || 'sequence';
  const topology = params.topology === 'circular' ? 'circular' : 'linear';
  const lines = [
    `LOCUS       ${locus.padEnd(16)} ${String(seq.length).padStart(6)} bp    DNA     ${topology}      SYN`,
    `DEFINITION  ${params.definition ?? params.name}.`,
    'FEATURES             Location/Qualifiers',
  ];
  for (const feature of params.features ?? []) {
    const loc =
      feature.end > params.codes.length
        ? `join(${feature.start + 1}..${params.codes.length},1..${feature.end - params.codes.length})`
        : feature.strand === -1
          ? `complement(${feature.start + 1}..${feature.end})`
          : `${feature.start + 1}..${feature.end}`;
    lines.push(`     ${feature.type.padEnd(16)}${loc}`);
    if (feature.name) lines.push(`                     /label="${feature.name.replace(/"/g, '')}"`);
  }
  lines.push('ORIGIN');
  for (let offset = 0; offset < seq.length; offset += 60) {
    const row = seq.slice(offset, offset + 60);
    const groups: string[] = [];
    for (let i = 0; i < row.length; i += 10) groups.push(row.slice(i, i + 10));
    lines.push(`${String(offset + 1).padStart(9, ' ')} ${groups.join(' ')}`);
  }
  lines.push('//');
  return `${lines.join('\n')}\n`;
}
